import { useState, useEffect } from 'react'
import { projectAuth,firebaseT } from '../firebase/config'
import { useAuthContext } from './useAuthContext'
// import  {useNavigate}  from 'react-router-dom';



export const useLogin = () => {
  const [isCancelled, setIsCancelled] = useState(false)
  const [error, setError] = useState(null)
  const [isPending, setIsPending] = useState(false)
  const { dispatch } = useAuthContext()
  // const history = useNavigate()

  const login = async (email,password) => {
    setError(null)
    setIsPending(true)
  
    try {
      // login
      const res = await projectAuth.signInWithEmailAndPassword(email,password)

      // dispatch login action
      dispatch({ type: 'LOGIN', payload: res.user })

      if (!isCancelled) {
        setIsPending(false)
        setError(null)
      }
    } 
    catch(err) {
      if (!isCancelled) {
        setError(err.message)
        setIsPending(false)
      }
    }
  }

  const signInWithGoogle = async () => {
    const provider = new firebaseT.GoogleAuthProvider();
    await projectAuth.signInWithPopup(provider);
  };

  useEffect(() => {
    return () => setIsCancelled(true)
  }, [])

  return { login, isPending, error,signInWithGoogle }
}